import { formService, TypeClassTemplate } from '../../../../../../cdm/services/form-service';
import { groupTypeIds, typeClassIds } from '../../../../../../config/variable-config';

let template = new TypeClassTemplate(typeClassIds.caregiverProfile);

export const caregiverForm = member => {
  if (!template || !template.form) return null;

  for (let field of template.form) {
    if (field.name === "firstName") {
      field.value = member.profile.data.firstName;
    }
    if (field.name === "lastName") {
      field.value = member.profile.data.lastName;
    }
    if (field.name === "email") {
      field.value = member.profile.data.email;
    }
    if (field.name === "phone") {
      field.value = member.profile.data.phone;
    }
  }

  // for (let field of template.form) {
  //   if (field.flags) {
  //     if (!field.flags.caregiver) field.disabled = true;
  //   }
  // }

  formService.hideFieldsByGroupTypeId(template.form, groupTypeIds.caregiver);
  return template.form;
};
